export class Annonceur {
    public id: Number;
    public login: String;
    public mail: String;
}
